var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"font display",attrs:{"variant":"outline"},on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('p-icon',{attrs:{"icon":"IconChevronLeft","size":"12"}}),_c('span',[_vm._v(_vm._s(_vm.$t("button.backDashBoard")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }